import { LOAN_YEAR_PLACEHOLDER } from './forgiveness-standard-messaging-constants';
import { ppp21LoanVersions } from '../forgiveness-summary-tile-constants';

export function fillLoanYear(message, loanVersion) {
  const loanYear = ppp21LoanVersions.includes(loanVersion) ? '2021' : '2020';
  return message.replace(LOAN_YEAR_PLACEHOLDER, loanYear);
}
